import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import './layout.css';

import defaultImage from '../images/sixstories.jpg';
import twitterImage from '../images/sixstories-twitter.jpg';
import vkImage from '../images/sixstories-vk.jpg';

const Layout = ({ children }) => (
  <React.Fragment>
    <Helmet
      htmlAttributes={{ lang: 'ru' }}
      titleTemplate="%s | 6 откровенных историй людей, которые смотрят порно"
    >
      <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" />

      <meta name='description' content='' />
      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:site' content='@bazabazon' />
      <meta name='twitter:creator' content='@bazabazon' />
      <meta name='twitter:title' content='6 откровенных историй людей, которые смотрят порно' />
      <meta name='twitter:image' content={`https://sixstories.baza.io${twitterImage}`} />
      <meta name='twitter:description' content='' />

      <meta property='og:type' content='website' />
      <meta property='og:url' content='https://sixstories.baza.io/' />
      <meta property='og:image' content={`https://sixstories.baza.io${defaultImage}`} />
      <meta property='og:image:width' content='1200' />
      <meta property='og:image:height' content='630' />
      <meta property='og:title' content='6 откровенных историй людей, которые смотрят порно' />
      <meta property='og:site_name' content='sixstories.baza.io' />
      <meta property='og:description' content='&nbsp;' />

      <meta property='vk:title' content='6 откровенных историй людей, которые смотрят порно' />
      <meta property='vk:image' content={`https://sixstories.baza.io${vkImage}`} />
      <meta property='vk:app_id' content='6751677' />
      <meta property='fb:app_id' content='508001523036506' />
    </Helmet>

    {children}
  </React.Fragment>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
